
import React from 'react';
import '../css/LessonCard.scss'; // For styling the card

/**
 * A component to display a single lesson in a card format.
 *
 * @param {object} lesson - The lesson object to display.
 */
const LessonCard = ({ lesson }) => {
  // Destructure for easier access to lesson properties
  const { title, description, category, difficulty, url } = lesson;

  return (
    <div className="lesson-card">
      <div className="card-content">
        <div className="card-meta">
          <span className="badge category-badge">{category}</span>
          {/* We can add a class based on difficulty for specific styling */}
          <span className={`badge difficulty-badge difficulty-${difficulty.toLowerCase()}`}>
            {difficulty}
          </span>
        </div>
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="card-button"
      >
        View Lesson
      </a>
    </div>
  );
};

export default LessonCard;